const suggestions = [
  "Burgers, Banh Mi, Barbecue",
  "Chinese, Coffee, Cajun, Crepes",
  "Donuts, Deli, Dim Sum",
  "Egyptian, Edamame, Egg Rolls",
  "Fancy Fish and Chips?",
  "Greek, Gnocchi, Grilled",
  "Pizza perhaps?",
  "Tacos, Thai, takeout",
  "Ramen, Rotisserie, Rigatoni",
  "Sandwiches, Sushi, Salad",
];

module.exports = { suggestions };
